// Actions
export const SET_CACHE = 'gCache/SET_CACHE';

export const setCache = payload => {
    return dispatch => {
        dispatch({
            type : SET_CACHE,
            payload
        });
    };
};


